import * as React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardStyle } from './Card';
import { Guide, GuideStats } from '../guide';

export interface GuideCardProps {
  stats?: GuideStats;
  guide: Guide;
}

const formatValue = (value: number) => {
  return !value ? <span className="black-30">—</span> : value;
};

export const GuideStatsInfo = (props: any) => (
  <ul className="flex justify-between tc ma0 pa0">
    <li className="flex flex-column">
      <h6 className="h2 ma0 lh-copy f6 ttu black-40 ttu">Downloads</h6>
      {formatValue(props.downloads)}
    </li>
    <li className="flex flex-column">
      <h6 className="h2 ma0 lh-copy f6 ttu black-40 ttu">Brews</h6>
      {formatValue(props.prepared)}
    </li>
    <li className="flex flex-column">
      <h6 className="h2 ma0 lh-copy f6 ttu black-40 ttu">Engagement</h6>
      {formatValue(props.favourites + props.shared)}
    </li>
  </ul>
);

export const GuideCard = ({ guide, stats }: GuideCardProps) => (
  <Card className={`${CardStyle.Default} animated fadeIn`}>
    <h6 className="h2 ma0 lh-copy f6 ttu black-70">guides.filtru.coffee/{guide.public_url}</h6>
    <h3 className="h2 f3 ma0"><Link to={{
      pathname: `/guides/${guide.id}`,
      state: { guide },
    }} className="link black">{guide.name}</Link></h3>
    <div>
      <img
        className="w4 h4 br-100 dib"
        src={`/images/methods/${guide.method}.png`}
        alt={guide.name}
      />
    </div>
    <div className="h3 w-100">{stats && <GuideStatsInfo {...stats} />}</div>
  </Card>
);
